var _path, _path2, _path3, _path4, _path5, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCeleb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 64,
    viewBox: "0 0 71 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3649 28.2543C68.1246 29.2428 67.6028 30.1403 66.8626 30.8382L56.948 40.5124C56.8477 40.6179 56.7664 40.7398 56.7076 40.873C56.6785 41.0117 56.6785 41.1549 56.7076 41.2936L59.0511 54.9938C59.2464 56.0033 59.1412 57.0488 58.7507 57.9982C58.3888 58.9376 57.7496 59.7445 56.9179 60.3117C56.1099 60.908 55.154 61.2717 54.1539 61.3632H53.7633C52.8828 61.3651 52.0156 61.1483 51.2396 60.7323L38.9214 54.3028C38.7935 54.229 38.6484 54.1901 38.5008 54.1901C38.3531 54.1901 38.208 54.229 38.0801 54.3028L25.762 60.7623C24.8379 61.246 23.798 61.4644 22.7575 61.3933C21.747 61.3072 20.78 60.9432 19.9634 60.3417C19.1396 59.7533 18.5033 58.9395 18.1307 57.9982C17.7505 57.0448 17.6464 56.0036 17.8303 54.9938L20.1737 41.3236C20.2174 41.1868 20.2174 41.0398 20.1737 40.903C20.127 40.7706 20.0556 40.6483 19.9634 40.5425L10.0488 30.8081C9.3285 30.1116 8.81839 29.2267 8.57659 28.2543C8.28437 27.2742 8.28437 26.2301 8.57659 25.2499C8.90688 24.2852 9.50176 23.4328 10.2933 22.79C11.0849 22.1471 12.0412 21.7398 13.0532 21.6145L26.5732 19.6316C26.7079 19.6282 26.8364 19.5746 26.9337 19.4814C27.0482 19.3936 27.1408 19.2805 27.2041 19.1509L33.5134 6.59236C33.943 5.69103 34.622 4.9309 35.4663 4.39912C36.108 3.99388 36.8282 3.72906 37.5796 3.62207C38.331 3.51507 39.0965 3.56833 39.8258 3.77833C40.5551 3.98833 41.2318 4.35032 41.8112 4.8405C42.3906 5.33069 42.8597 5.93796 43.1877 6.6224L49.4369 19.1209C49.5124 19.2596 49.6145 19.3821 49.7374 19.4814C49.8467 19.5744 49.9844 19.6274 50.1279 19.6316L63.8582 21.6145C64.8557 21.7648 65.7931 22.1914 66.5622 22.8464C67.3163 23.4983 67.8871 24.3366 68.2146 25.2799C68.5331 26.2414 68.5872 27.2689 68.3649 28.2543Z",
    fill: "#E8D8FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5074 26.3198C64.2672 27.3082 63.7454 28.2058 63.0052 28.9036L53.0906 38.5779C52.9903 38.6833 52.909 38.8053 52.8502 38.9384C52.821 39.0771 52.821 39.2203 52.8502 39.359L55.1937 53.0592C55.389 54.0687 55.2838 55.1143 54.8932 56.0637C54.5314 57.003 53.8921 57.8099 53.0605 58.3771C52.2525 58.9735 51.2966 59.3371 50.2964 59.4286H49.9059C49.0254 59.4305 48.1582 59.2137 47.3821 58.7977L35.064 52.3682C34.9361 52.2944 34.791 52.2555 34.6433 52.2555C34.4957 52.2555 34.3506 52.2944 34.2227 52.3682L21.9045 58.8278C20.9805 59.3114 19.9406 59.5298 18.9001 59.4587C17.8896 59.3726 16.9225 59.0086 16.106 58.4071C15.2822 57.8187 14.6458 57.005 14.2733 56.0637C13.8931 55.1102 13.789 54.0691 13.9728 53.0592L16.3163 39.3891C16.36 39.2523 16.36 39.1052 16.3163 38.9684C16.2696 38.8361 16.1982 38.7137 16.106 38.6079L6.19134 28.8735C5.47107 28.177 4.96097 27.2921 4.71917 26.3198C4.42694 25.3396 4.42694 24.2955 4.71917 23.3153C5.04946 22.3506 5.64434 21.4982 6.4359 20.8554C7.22746 20.2126 8.18381 19.8053 9.19578 19.68L22.7157 17.697C22.8504 17.6936 22.979 17.6401 23.0763 17.5468C23.1908 17.4591 23.2833 17.3459 23.3467 17.2163L29.656 4.65779C30.0856 3.75646 30.7646 2.99633 31.6089 2.46455C32.2506 2.05931 32.9708 1.79449 33.7222 1.6875C34.4736 1.5805 35.2391 1.63376 35.9684 1.84376C36.6977 2.05376 37.3743 2.41575 37.9538 2.90593C38.5332 3.39612 39.0023 4.00339 39.3303 4.68783L45.5795 17.1863C45.655 17.325 45.7571 17.4475 45.8799 17.5468C45.9892 17.6399 46.127 17.6929 46.2705 17.697L60.0008 19.68C60.9983 19.8302 61.9356 20.2568 62.7048 20.9118C63.4589 21.5637 64.0297 22.402 64.3572 23.3454C64.6757 24.3068 64.7298 25.3343 64.5074 26.3198Z",
    fill: "#F7F0FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 35.7686C26.8907 37.3151 33.6509 39.4802 39.6282 35.7686",
    stroke: "#B076F9",
    strokeWidth: 1.94008,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2334 27.5708C24.2866 29.1173 26.9906 31.2824 29.3816 27.5708",
    stroke: "#B076F9",
    strokeWidth: 1.94008,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4805 27.5708C34.5336 29.1173 37.2377 31.2824 39.6286 27.5708",
    stroke: "#B076F9",
    strokeWidth: 1.94008,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2021_524)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.5,
    cy: 32,
    rx: 4,
    ry: 1,
    fill: "#D2B1FC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2021_524)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5,
    cy: 32,
    rx: 4,
    ry: 1,
    fill: "#D2B1FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2021_524",
    x: 33.5,
    y: 27,
    width: 16,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2021_524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2021_524",
    x: 13.5,
    y: 27,
    width: 16,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2021_524"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCeleb);
export default __webpack_public_path__ + "static/media/iconCeleb.1cb2a146c971b9335f13dfc47e63105c.svg";
export { ForwardRef as ReactComponent };